<template>
  <div class="left-menu-admin">
    <!-- 头部区域 -->
    <Header :isDrawer='isDrawer' @drawerChange='drawerChange'></Header>
    <!-- 工具区域 -->
    <div class="tool-area">
        <ToolArea @drawerChange='drawerChange' v-if="isShowLeftTool"></ToolArea>
        <KnowledgeTool v-if="!isShowLeftTool"></KnowledgeTool>
    </div>
    <!-- 用户区 -->
    <div class="user-area" v-if="isLogin">
        <UserArea @drawerChange='drawerChange'></UserArea>
    </div>
  </div>
</template>

<script>
import UserArea from "./UserArea.vue"
import Header from "./Header.vue"
import ToolArea from "./ToolArea.vue"
import KnowledgeTool from './KnowledgeTool.vue'
import { mapState } from 'vuex'
export default {
    props:{
        isDrawer:{
            type: Boolean,
            default: false
        }
    },
  watch:{
      '$route':{
        handler(to,from) {
          this.fullPath = from.fullPath
          sessionStorage.setItem('weidun_fullPath',from.fullPath)
        }
      }
  },
  computed:{
      isShowLeftTool(){
        let aiRouter = ['ai','tankList','tank','history']
        if(aiRouter.indexOf(this.$route.name) != -1){
          return true
        }
        if(this.fullPath.indexOf('knowledge') != -1){
          return false
        }
        if(this.$route.path.indexOf('knowledge') == -1){
          return true
        }
        if(this.$route.path.indexOf('knowledge') != -1){
          return false
        }
      },
      ...mapState('channel',['isLogin'])
  },
    components:{
        UserArea,
        Header,
        ToolArea,
      KnowledgeTool
    },
    data() {
        return {
          fullPath:sessionStorage.getItem('weidun_fullPath') || ''
        }
    },
    methods:{
        drawerChange() {
            this.$emit('drawerChange')
        }
    }
}
</script>

<style lang="scss" scoped>
.left-menu-admin{
    padding: 15px 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    .user-area{
        width: 100%;
        height: 40px;
        border-radius: 8px;
    }
    .tool-area{
        flex: 1;
        width: 100%;
        height: 100px;
        margin-bottom: 15px;
        overflow-y: auto;
    }
}
/* 隐藏滚动条 */
.tool-area::-webkit-scrollbar {
  width: 0;
}
 
.tool-area::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0);
}
</style>